"use strict";
/* tslint:disable */
// Inlined script in base.html produced using https://babeljs.io/repl/ with "Minify" and "es2015-loose" enabled
// Not using webpack because we do not have a build chain to achieve this singular inlined, minified set of code
(function() {
  // The following script requires the existence of IntersectionObserver and MutationObserver
  // IE11 does not support IntersectionObserver and requires a polyfill. MutationObserver exists in all browsers.
  if ("IntersectionObserver" in window) {
    // Since IntersectionObserver exists we can immediately execute our script
    watchImages();
  } else {
    // IntersectionObserver is not present so we must load our polyfill. This specifically only polyfills IntersectionObserver
    // @see https://polyfill.io/v2/docs/api
    var s = document.createElement("script");
    // The querystring parameters tell polyfill.io to:
    //   (a) only load IntersectionObserver
    //   (b) always include it
    //   (c) don't do any UA sniffing (since we're checking above)
    s.src =
      "https://cdn.polyfill.io/v2/polyfill.min.js?features=IntersectionObserver,MutationObserver&flags=gated,always&ua=chrome/50";
      // When the polyfill is loaded, begin watching Images
    s.onload = watchImages;
    document.head.appendChild(s);
  }

  function watchImages() {
    // Initialized an IntersectionObvserver that will fire when observed elements scroll into the viewport
    // This observer will be significantly more efficient, cpu resource-wise, than polling position via scroll events.
    var intersection = new IntersectionObserver(
      function(entries) {
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          if (entry.isIntersecting) {
            var image = entry.target;
            // Since the image has at least partly scrolled into view, we can stop watching it as we will now load it.
            intersection.unobserve(image);

            // This image likely was here by mistake or duplicate, we should now eject early
            if (!image.hasAttribute("defer-src")) {
              return;
            }

            // Swap and remove defer-src with src to trigger the browser to load the image
            image.setAttribute("src", image.getAttribute("defer-src"));
            image.removeAttribute("defer-src");
          }
        }
      },
      {
        // If the image gets within 200px in the Y axis, start the download.
        rootMargin: "200px 0px"
      }
    );

    function observeImages(root) {
      // By default we want to see every image with a defer-src attribute
      // However sometimes we only want images present in newly-attached DOM nodes
      var images = (root || document).querySelectorAll("img[defer-src]");
      for (var i = 0; i < images.length; i++) {
        var node = images[i];
        observeImage(node);
      }
    }

    function observeImage(node) {
      // If the image doesn't have a defer-src attribute it won't be lazy-loaded anyways, so we shouldn't even bother observing.
      if (!node.hasAttribute("defer-src")) {
        return;
      }
      // This explicitly registers with the browser that we want to know live intersection details about this image.
      intersection.observe(node);
    }

    var mutation = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        // Watch for defer-src attribute changes
        if (mutations[i].type === "attributes" && mutations[i].attributeName === "defer-src") {
          observeImage(mutations[i].target);
          continue;
        }
        // We do not care about removed nodes as the browser will handle observer cleanup
        var addedNodes = mutations[i].addedNodes;
        for (var j = 0; j < addedNodes.length; j++) {
          // An added node is effectively whatever was passed to .appendChild() or similar.
          var node = addedNodes[j];
          // ...If an image was added directly, our node is the image so we should observe it
          if (node.nodeName === "IMG") {
            observeImage(node);
            continue;
          }
          // ...If the node added was a #text node, it won't have children so don't bother checking
          if (typeof node.querySelectorAll !== "function") {
            continue;
          }
          // ...If the node added was anything else, it _may_ have images as children so we should check only its children
          observeImages(node);
        }
      }
    });

    // MutationObserver will not report images present prior to instantiation, so we should check and observe existing images
    observeImages();
    // ...However now that we've checked, we should begin observing mutations to catch any images added by Javascript, etc
    mutation.observe(document, {
      childList: true,
      subtree: true,
      attributeFilter: ["defer-src"],
      attributes: true
    });
  }
})();
